var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgS4UserIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 41,
    height: 48,
    viewBox: "0 0 41 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20.3935 0C13.7757 0 8.37575 5.26191 8.11775 11.8198C8.11175 11.9818 8.09375 12.1378 8.09375 12.2998C8.09375 12.6718 8.11775 13.0318 8.14775 13.3978C8.63374 18.8277 12.6537 23.2556 17.8916 24.3416C18.6956 24.5096 19.5356 24.5996 20.3875 24.5996C21.2395 24.5996 22.1155 24.5036 22.9375 24.3296C27.1794 23.4296 30.6114 20.3337 32.0033 16.2957C32.4353 15.0417 32.6813 13.6978 32.6813 12.2998C32.6813 11.0278 32.4893 9.80383 32.1293 8.64585C30.5694 3.64194 25.8954 0 20.3875 0H20.3935Z",
    fill: "#F37A50"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M12.4738 47.6332C14.8737 47.4052 17.5857 47.1532 20.3937 47.1532C23.2016 47.1532 25.9136 47.4052 28.3135 47.6332C33.1854 48.0892 37.0374 48.4432 39.0353 46.6192C40.2173 45.5512 40.7873 43.6552 40.7873 40.8293C40.7873 33.0474 36.4014 26.2675 29.9695 22.8296C27.4375 25.1336 24.0776 26.5375 20.3937 26.5375C16.7097 26.5375 13.3498 25.1276 10.8178 22.8296C4.38593 26.2675 0 33.0474 0 40.8293C0 43.6552 0.56999 45.5512 1.75197 46.6192C3.74994 48.4432 7.60187 48.0832 12.4738 47.6332ZM24.5396 33.0954C24.9596 32.4534 25.6736 32.0694 26.4415 32.0694H32.3694C33.1434 32.0694 33.8574 32.4534 34.2774 33.0954C34.6914 33.7374 34.7634 34.5354 34.4634 35.2374C33.5874 37.2473 31.6015 38.5493 29.4055 38.5493C27.2095 38.5493 25.2296 37.2473 24.3536 35.2374C24.0476 34.5354 24.1196 33.7374 24.5396 33.0954Z",
    fill: "#F37A50"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgS4UserIcon);
export default __webpack_public_path__ + "static/media/s4-user-icon.1f29e161bb1146aeb1af2aa53fdddf0b.svg";
export { ForwardRef as ReactComponent };